import React from 'react'
import { Parser } from '../../common'

const Group = ({ block }) => {
    return block.childrens ? <Parser content_block={block.childrens} parent={block?.block} /> : null
}

export default Group
